<template>
  <refonte-modal
    v-bind:show="props.show"
    v-on:close="props.on_close"
    title="Signature en cours"
    class="!max-w-[720px]">
    <template v-slot:modalBody>
      <div
        class="flex-col gap-[12px]"
        v-if="props.show_body">
        Un lien de signature a été envoyé par e-mail à
        <span class="font-bold">{{ email }}</span> le
        <span class="font-bold">{{ formatDate(props.date) }}</span
        >.<br /><br />
        Veuillez effectuer la signature depuis cet e-mail ; le document signé
        sera ensuite disponible ici.
      </div>
    </template>
  </refonte-modal>
</template>

<script setup lang="ts">
  import RefonteModal from '@/components/refonte/modals/refonte-modal.vue';
  import { parse } from 'date-fns';
  import { computed } from 'vue';
  import { store } from '@/store';

  const props = withDefaults(
    defineProps<{
      show: boolean;
      on_close: Function;
      class?: string;
      show_body: boolean;
      date?: string;
    }>(),
    {
      class: ''
    }
  );

  const email = computed(() => store.getters['auth/email']);

  const formatDate = (dateString: string | undefined) => {
    if (!dateString) return '';

    const date = parse(dateString, 'dd/MM/yyyy HH:mm:ss', new Date());

    const datePart = date.toLocaleDateString('fr-FR');
    const timePart = date
      .toLocaleTimeString('fr-FR', {
        hour: '2-digit',
        minute: '2-digit'
      })
      .replace(':', 'h');

    return `${datePart} à ${timePart}`;
  };
</script>

<style lang="scss" scoped></style>
